/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 public/yacht-base.glb 
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export function Yacht_Full(props) {
  const { nodes, materials } = useGLTF('/yacht-base.glb')
  return (
    <group {...props} dispose={null} scale={10}>
      <mesh castShadow receiveShadow geometry={nodes.linie_kadlub.geometry} material={materials.wire_086086086} material-color={'#000'} />
      <mesh castShadow receiveShadow geometry={nodes.matress.geometry} material={materials.white_leather} />
      <mesh castShadow receiveShadow geometry={nodes.Object_10.geometry} material={materials['02___Default']} />
      <mesh castShadow receiveShadow geometry={nodes.Object_13.geometry} material={materials['09___Default']} />
      <mesh castShadow receiveShadow geometry={nodes.Object_14.geometry} material={materials['11___Default']} />
      <mesh castShadow receiveShadow geometry={nodes.Object_16.geometry} material={materials.chrome} />
      <mesh castShadow receiveShadow geometry={nodes.Object_17.geometry} material={materials.chrome} />
      <mesh castShadow receiveShadow geometry={nodes.Object_18.geometry} material={materials.chrome} />
      <mesh castShadow receiveShadow geometry={nodes.Object_19.geometry} material={materials.chrome} />
      <mesh castShadow receiveShadow geometry={nodes.Object_20.geometry} material={materials.chrome} />
      <mesh castShadow receiveShadow geometry={nodes.Object_21.geometry} material={materials.chrome} />
      <mesh castShadow receiveShadow geometry={nodes.Object_22.geometry} material={materials.chrome} />
      <mesh castShadow receiveShadow geometry={nodes.Object_23.geometry} material={materials.glass} />
      <mesh castShadow receiveShadow geometry={nodes.Object_7.geometry} material={materials['02___Default']} />
      <mesh castShadow receiveShadow geometry={nodes.Object_8.geometry} material={materials['02___Default.003']} />
      <mesh castShadow receiveShadow geometry={nodes.plastik.geometry} material={materials['02___Default.003']} material-color={'#fff'}/>
      <mesh castShadow receiveShadow geometry={nodes.zegary.geometry} material={materials['02___Default']} />
      <mesh castShadow receiveShadow geometry={nodes.Object_19001.geometry} material={materials.chrome} />
      <mesh castShadow receiveShadow geometry={nodes.Object_19001_1.geometry} material={materials['02___Default.003']} />
    </group>
  )
}

useGLTF.preload('/yacht-base.glb')
